// NOTE: This file gets overwritten by buildspec-post.yml
export const COGNITO = {
  REGION: 'ap-southeast-2',
  USER_POOL_ID: 'ap-southeast-2_8IYi5n6ai',
  APP_CLIENT_ID: 'lintfjur0qdo27ftan68l9r5c',
  API_HOST: 'https://4wieg8l93f.execute-api.ap-southeast-2.amazonaws.com/P',
  USER_POOL_DOMAIN: 'firecicdadminprod'
};
export const ENV = {
  ENV_NAME: 'P'
}
